import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Typography,
  LinearProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { SignatureSection } from "./SignatureCanvas";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../utils/axiosConfig";

export const PhotoSection = ({
  selectedSchedule,
  currentUser,
  handlePhotoUpload,
  setSelectedSchedule,
  handleCompleteService,
}) => {
  const { t } = useTranslation();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  const handleDeletePhoto = async (photoId) => {
    try {
      const response = await axiosInstance.delete(
        `/schedules/${selectedSchedule.id}/photos/${photoId}`
      );
      const updatedSchedule = await response.data;
      setSelectedSchedule(updatedSchedule);
    } catch (error) {
      console.error("Error deleting photo:", error);
    }
  };

  const onFilesChange = async (files) => {
    if (files.length === 0) return;
    setUploading(true);
    try {
      await handlePhotoUpload(files, (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadProgress(percentCompleted);
      });
    } catch (error) {
      console.error("Error uploading photos:", error);
    }
    setUploading(false);
    setUploadProgress(0);
  };

  return (
    <Box
      sx={{
        width: window.innerWidth <= 768 ? "100%" : "60%",
        flex: window.innerWidth <= 768 ? "1" : "none",
        borderLeft: window.innerWidth <= 768 ? "none" : "1px solid #e0e0e0",
        borderTop: window.innerWidth <= 768 ? "1px solid #e0e0e0" : "none",
        padding: window.innerWidth <= 768 ? "20px 0" : "20px 30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "25px",
      }}
    >
      <Typography variant="h6">{t("servicePhotos")}</Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: "20px",
          width: "100%",
        }}
      >
        {selectedSchedule?.photos_urls?.map((photo, index) => (
          <Box key={photo.id} sx={{ position: "relative" }}>
            <img
              src={photo.url}
              alt={`${t("servicePhotos")} ${index + 1}`}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
            <IconButton
              onClick={() => handleDeletePhoto(photo.id)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                backgroundColor: "rgba(255,255,255,0.8)",
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
      </Box>

      {uploading && (
        <Box sx={{ width: "100%" }}>
          <Typography variant="body2">
            {t("uploadingPhotos")}: {uploadProgress}%
          </Typography>
          <LinearProgress variant="determinate" value={uploadProgress} />
        </Box>
      )}

      <input
        type="file"
        accept="image/*"
        multiple
        onChange={(e) => onFilesChange(e.target.files)}
        style={{ display: "none" }}
        id="photo-upload"
      />
      <Button
        variant="contained"
        onClick={() => document.getElementById("photo-upload").click()}
        disabled={
          (selectedSchedule?.status === "completed" &&
            currentUser !== "admin") ||
          (currentUser !== "admin" && !selectedSchedule.service_started_at)
        }
      >
        {t("uploadPhotos")}
      </Button>
      <SignatureSection
        currentUser={currentUser}
        selectedSchedule={selectedSchedule}
        setSelectedSchedule={setSelectedSchedule}
        handleCompleteService={handleCompleteService}
      />
    </Box>
  );
};
